import { Button, Flex, Typography } from 'antd';
import { FULL_DATE_FORMAT } from 'constants/dates';
import dayjs from 'dayjs';
import { FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { StyledItem } from './styled';

interface IProps {
  name: string;
  date: string;
  id: string;
}

const { Paragraph } = Typography;

const ResultItem: FC<IProps> = ({ name, date, id }) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const onOpenResult = () => {
    searchParams.set('result_id', id);
    setSearchParams(searchParams);
  };

  return (
    <StyledItem>
      <Paragraph>{name.replace(/(^"|"$)/g, '')}</Paragraph>
      <Flex gap={50} align="center">
        <Paragraph style={{ color: '#63687A', fontSize: 14 }}>
          {dayjs(date).format(FULL_DATE_FORMAT)}
        </Paragraph>
        <Button
          onClick={onOpenResult}
          style={{ borderColor: '#2552F3' }}
          type="default"
          size="large"
        >
          <Paragraph style={{ color: '#2552F3' }}>
            {t('patient.view_results')}
          </Paragraph>
        </Button>
      </Flex>
    </StyledItem>
  );
};

export default ResultItem;
